// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.historic {
  min-height: 80vh;
  overflow: auto;
  position: relative;
}
.historic::-webkit-scrollbar {
  width: 0.7em;
  height: 0.7em;
}
.historic::-webkit-scrollbar-thumb {
  background: #3b00f8;
}
.historic::-webkit-scrollbar-track {
  background: #9d80fc;
}
@media (max-width: 600px) {
  .historic::-webkit-scrollbar {
    width: 0em;
    height: 0em;
  }
  .historic::-webkit-scrollbar-thumb {
    background: #fff;
  }
  .historic::-webkit-scrollbar-track {
    background: white;
  }
}
.historic .page_number {
  position: absolute;
  top: 0px;
  right: 8px;
  font-weight: 700;
}
.historic .historic_search {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 1vw;
  margin: 1vh auto;
}
.historic .historic_search input {
  height: 4vh;
  border: 1px solid #151042;
  border-radius: 5px;
  width: 200px;
  text-align: center;
  font-size: 1.2rem;
}
.historic .historic_search button {
  width: 200px;
}
@media (max-width: 850px) {
  .historic .historic_search {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1vh;
  }
  .historic .historic_search button,
  .historic .historic_search input {
    width: 250px;
  }
}
@media (max-width: 850px) {
  .historic .historic_table td:nth-of-type(1):before {
    content: "Event Id";
  }
  .historic .historic_table td:nth-of-type(2):before {
    content: "End Location";
  }
  .historic .historic_table td:nth-of-type(3):before {
    content: "Type";
  }
  .historic .historic_table td:nth-of-type(4):before {
    content: "Priority";
  }
  .historic .historic_table td:nth-of-type(5):before {
    content: "Status";
  }
  .historic .historic_table td:nth-of-type(6):before {
    content: "Created";
  }
  .historic .historic_table td:nth-of-type(7):before {
    content: "Completed";
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/historic.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,gBCgBU;EDfV,cAAA;EAKA,kBAAA;AALJ;AC2DI;EACI,YD3DgB;EC4DhB,aD5DgB;AAGxB;AC4DI;EACI,mBAxDO;ADFf;AC6DI;EACI,mBAbe;AD9CvB;AARI;ECyDA;IACI,UDzDoB;IC0DpB,WD1DoB;EAY1B;ECiDE;IACI,gBA9DA;EDeN;ECkDE;IACI,iBAbe;EDnCrB;AACF;AAfI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;AAiBR;AAdI;ECWA,aAAA;EACA,uBDXkB;ECYlB,mBDZ0B;ECa1B,mBDbkC;ECclC,QDduC;EACnC,gBAAA;AAoBR;AAnBQ;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAqBZ;AAnBQ;EACI,YAAA;AAqBZ;AAlBQ;EAfJ;ICWA,aAAA;IACA,uBDIsB;ICHtB,mBDG8B;ICF9B,sBDEsC;ICDtC,QDC8C;EAyBhD;EAxBU;;IAEI,YAAA;EA0Bd;AACF;AArBQ;EACI;IACI,mBAAA;EAuBd;EArBU;IACI,uBAAA;EAuBd;EArBU;IACI,eAAA;EAuBd;EArBU;IACI,mBAAA;EAuBd;EArBU;IACI,iBAAA;EAuBd;EArBU;IACI,kBAAA;EAuBd;EArBU;IACI,oBAAA;EAuBd;AACF","sourcesContent":["@import \"../../variables.scss\";\n\n.historic {\n    min-height: $main-height;\n    overflow: auto;\n    @include scrollbars(0.7em, $nitrocamBlue);\n    @media (max-width: $mobile) {\n        @include scrollbars(0em, $white);\n    }\n    position: relative;\n\n    .page_number {\n        position: absolute;\n        top: 0px;\n        right: 8px;\n        font-weight: 700;\n    }\n\n    .historic_search {\n        @include flex(center, center, row, 1vw);\n        margin: 1vh auto;\n        input {\n            height: 4vh;\n            border: 1px solid $nitrocamDarkBlue;\n            border-radius: 5px;\n            width: 200px;\n            text-align: center;\n            font-size: 1.2rem;\n        }\n        button {\n            width: 200px;\n        }\n\n        @media (max-width: 850px) {\n            @include flex(center, center, column, 1vh);\n            button,\n            input {\n                width: 250px;\n            }\n        }\n    }\n\n    .historic_table {\n        @media (max-width: 850px) {\n            td:nth-of-type(1):before {\n                content: \"Event Id\";\n            }\n            td:nth-of-type(2):before {\n                content: \"End Location\";\n            }\n            td:nth-of-type(3):before {\n                content: \"Type\";\n            }\n            td:nth-of-type(4):before {\n                content: \"Priority\";\n            }\n            td:nth-of-type(5):before {\n                content: \"Status\";\n            }\n            td:nth-of-type(6):before {\n                content: \"Created\";\n            }\n            td:nth-of-type(7):before {\n                content: \"Completed\";\n            }\n        }\n    }\n}\n","//Colors\n$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n$white: #fff;\n$black: #000;\n$success: #b6fcc9;\n$green: #357a38;\n\n$nitrocamDarkBlue: #151042;\n$nitrocamBlue: #3b00f8;\n$nitrocamRed: #ff161b;\n$nitrocamYellow: #ffe169;\n\n//Heights\n$nav-height: 10vh;\n$main-height: 80vh;\n$footer-height: 6vh;\n\n//Breakpoints\n$mobile: 600px;\n$tablet: 1000px;\n$desktop: 1300px;\n\n//Layout\n@mixin flex($justify: center, $align: center, $direction: row, $gap: 10px) {\n    display: flex;\n    justify-content: $justify;\n    align-items: $align;\n    flex-direction: $direction;\n    gap: $gap;\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 60vh;\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 1000px) {\n        width: 92vw;\n    }\n}\n\n//Overflow\n@mixin scrollbars(\n    $size,\n    $foreground-color,\n    $background-color: mix($foreground-color, white, 50%)\n) {\n    // For Google Chrome\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: $foreground-color;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $background-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
